import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Taxi = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12.0652 0.686905C11.6352 0.686905 11.252 0.961499 11.116 1.3705L11.0106 1.6869H9.44415C6.84415 1.6869 4.67773 3.68084 4.46173 6.27284L4.159 9.90761C2.81218 10.3948 1.84454 11.672 1.84454 13.1869V18.6869C1.29254 18.6869 0.844543 19.1349 0.844543 19.6869C0.844543 20.2389 1.29254 20.6869 1.84454 20.6869H2.84454V21.6869C2.84454 22.7919 3.73954 23.6869 4.84454 23.6869C5.94954 23.6869 6.84454 22.7919 6.84454 21.6869V20.6869H20.8445V21.6869C20.8445 22.7919 21.7395 23.6869 22.8445 23.6869C23.9495 23.6869 24.8445 22.7919 24.8445 21.6869V20.6869H25.8445C26.3965 20.6869 26.8445 20.2389 26.8445 19.6869C26.8445 19.1349 26.3965 18.6869 25.8445 18.6869V13.1869C25.8445 11.672 24.8769 10.3948 23.5301 9.90761L23.2274 6.27284C23.0114 3.68084 20.844 1.6869 18.243 1.6869H16.6785L16.5731 1.3705C16.4371 0.961499 16.0548 0.686905 15.6238 0.686905H12.0652ZM9.44611 3.6869H18.2449C19.7929 3.6869 21.1062 4.89586 21.2352 6.43886L21.5125 9.79823C21.5041 9.80031 21.4955 9.80197 21.4871 9.80409C19.7281 9.26809 17.0825 8.6869 13.8445 8.6869C10.6065 8.6869 7.96097 9.26809 6.20197 9.80409C6.19361 9.80197 6.18495 9.80031 6.17657 9.79823L6.45587 6.43886C6.58487 4.89586 7.89811 3.6869 9.44611 3.6869ZM5.34454 11.6869C6.17254 11.6869 6.84454 12.3589 6.84454 13.1869C6.84454 14.0149 6.17254 14.6869 5.34454 14.6869C4.51654 14.6869 3.84454 14.0149 3.84454 13.1869C3.84454 12.3589 4.51654 11.6869 5.34454 11.6869ZM13.8445 11.6869C15.5015 11.6869 16.8445 13.0299 16.8445 14.6869V17.6869C16.8445 18.2389 16.3965 18.6869 15.8445 18.6869H11.8445C11.2925 18.6869 10.8445 18.2389 10.8445 17.6869V14.6869C10.8445 13.0299 12.1875 11.6869 13.8445 11.6869ZM22.3445 11.6869C23.1725 11.6869 23.8445 12.3589 23.8445 13.1869C23.8445 14.0149 23.1725 14.6869 22.3445 14.6869C21.5165 14.6869 20.8445 14.0149 20.8445 13.1869C20.8445 12.3589 21.5165 11.6869 22.3445 11.6869Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 27 24" width="27" height="24">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Taxi };